export type AlternativeMap = Record<string, string[]>;

export class ArticleChooser {
  static findAlternative(articleId: string, validArticles: string[], alternativeMap: AlternativeMap | undefined): string | undefined {
    if (validArticles.length > 0) {
      if (alternativeMap) {
        const alternatives = alternativeMap[articleId];
        if (alternatives) {
          for (const a of alternatives) {
            if (validArticles.includes(a))
              return a;
          }
        }
      }
      return validArticles[0];
    }
    return undefined;
  }

  static findValidArticle(articleId: string, validArticles: string[], alternativeMap?: AlternativeMap): string | undefined {
    if (validArticles.includes(articleId))
      return articleId;

    return ArticleChooser.findAlternative(articleId, validArticles, alternativeMap)
  }

  static findValidArticleObject<T extends { articleNumber: string }>(articleId: string | undefined, validArticles: T[]): T | undefined {
    if (articleId) {
      const foundArticle = validArticles.find((v) => v.articleNumber === articleId);
      if (foundArticle) {
        return foundArticle;
      }
    }
    if (validArticles.length > 0)
      return validArticles[0];

    return undefined;
  }
}